import { OrganizationDepartmentBySlugRecord } from '@navio/nsdk';

interface Props {
  department: OrganizationDepartmentBySlugRecord;
}

export const PublicFleetCalendarHeader = ({ department }: Props) => {
  const logoUrl = department.logo?.url ?? department.organization?.logo?.url;

  return (
    <div className='flex flex-col gap-2 text-balance'>
      <div className='flex items-center gap-3'>
        {logoUrl && <img src={logoUrl} alt={department.name} className='size-10 shrink-0 object-contain md:size-12' />}
        <h1 className='text-3xl font-bold text-primary md:text-4xl'>{department.name}</h1>
      </div>
      {department.organization?.name && (
        <span className='text-sm font-medium md:text-base'>{department.organization.name}</span>
      )}
    </div>
  );
};
